<div class="editable-cell" [ngClass]="{ 'editable-cell--editing': isEditing }">
    <p
        ellipsis
        class="editable-cell__text"
        *ngIf="!isEditing"
        [ngClass]="{ 'editable-cell__of-that-item': type === 'OF_THAT_ITEM' }"
    >
        {{ value }}
    </p>
    <input
        class="editable-cell__input"
        *ngIf="isEditing"
        [(ngModel)]="editValue"
        (blur)="handleOnSave()"
        #input
        (keydown.enter)="preventDefault($event); handleOnSave()"
        (keydown.space)="preventDefault($event)"
        stopPropagation
    />

    <span
        *ngIf="isEditing"
        class="editable-cell__display-on-hover editable-cell__save-icon editable-cell__save-icon"
        (click)="handleOnSave()"
        stopPropagation
    >
        <mat-icon svgIcon="save"></mat-icon>
    </span>
</div>
